import LogEntry from './LogEntry';
import { LogEntryProps, LogEntryValueProps } from './types';

export type { LogEntryProps, LogEntryValueProps };
export default LogEntry;
